export default function Footer() {
  const footerLinks = {
    Product: [
      { label: "Translate Cloud API", href: "https://translate.saas.forcekeys.com" },
      { label: "API Docs", href: "https://translate.saas.forcekeys.com/docs" },
      { label: "Pricing", href: "#pricing" },
    ],
    Services: [
      { label: "SaaS Development", href: "https://saas.forcekeys.com/#services" },
      { label: "API Integration", href: "https://translate.saas.forcekeys.com/docs" },
      { label: "DevOps", href: "https://forcekeys.com/#services" },
    ],
    Company: [
      { label: "About", href: "https://forcekeys.com/about" },
      { label: "Contact", href: "https://forcekeys.com/#contact" },
    ],
    Support: [
      { label: "Help Center", href: "https://support.saas.forcekeys.com" },
      { label: "Documentation", href: "https://support.saas.forcekeys.com" },
      { label: "Privacy", href: "https://forcekeys.com/privacy" },
      { label: "Terms", href: "https://forcekeys.com/terms" },
    ],
  };

  const socialLinks = [
    { icon: "ri-github-line", href: "#", label: "GitHub" },
    { icon: "ri-twitter-x-line", href: "#", label: "Twitter" },
    { icon: "ri-linkedin-line", href: "#", label: "LinkedIn" },
    { icon: "ri-discord-line", href: "#", label: "Discord" },
  ];

  return (
    <footer className="bg-[#111827] text-gray-400 section-padding py-14 md:py-18 border-t border-white/5">
      <div className="container-wide">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 md:gap-6 mb-12 md:mb-16">
          <div className="col-span-2">
            <a href="#hero" className="flex items-center gap-2.5 mb-5">
              <div className="w-9 h-9 rounded-lg overflow-hidden flex-shrink-0 bg-white/10">
                <img
                  src="https://public.readdy.ai/ai/img_res/3ef87599-1241-4809-b65e-3d0fc5310a8f.png"
                  alt="SaaS ForceKeys Services logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="font-outfit font-bold text-lg text-white">
                SaaS ForceKeys Services
              </span>
            </a>
            <p className="text-sm leading-relaxed text-gray-500 max-w-xs mb-6">
              Building powerful <strong className="text-gray-300">SaaS applications</strong> for modern teams. <strong className="text-gray-300">Translate Cloud API</strong> unifies the world&apos;s best translation engines into one <strong className="text-gray-300">translation API</strong>.
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-9 h-9 rounded-lg bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors duration-300"
                  aria-label={social.label}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${social.icon} text-gray-400`} />
                  </div>
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="font-outfit font-semibold text-sm text-white mb-4">
                {category}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target={
                        link.href.startsWith("http") ? "_blank" : undefined
                      }
                      rel={
                        link.href.startsWith("http")
                          ? "noopener noreferrer nofollow"
                          : undefined
                      }
                      className="text-sm text-gray-500 hover:text-gray-300 transition-colors duration-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            &copy; 2026 SaaS ForceKeys Services. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="https://forcekeys.com/privacy"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-xs text-gray-500 hover:text-gray-300 transition-colors"
            >
              Privacy
            </a>
            <a
              href="https://forcekeys.com/terms"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-xs text-gray-500 hover:text-gray-300 transition-colors"
            >
              Terms
            </a>
            <a
              href="https://support.saas.forcekeys.com"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-xs text-emerald-400 hover:text-emerald-300 transition-colors"
            >
              Support Portal
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
